export const CUSTOM_DATE = 'pickCustomDate';